// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"7c0e93e3","3874":"3f14a8dd","6443":"9a885429"}[chunkId] + ".css";
};